import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebookF, FaWhatsapp, FaInstagram, FaHeart } from "react-icons/fa";
import { FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import { Link } from 'react-router-dom';
import Logo from '../Header/Logo';
import './Footer.css';

const Footers = () => {
  const [currentYear] = useState(new Date().getFullYear());

  return (
    <footer className="hd-footer">
      <Container className="hd-footer-inner">
        <div className="hd-footer-top">
          <span className="hd-social-text">Rejoignez notre communauté</span>
          <div className="hd-social-icons">
            <a href={process.env.REACT_APP_FB} target="_blank" rel="noreferrer" className="hd-social-icon" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href={process.env.REACT_APP_WHATSAPP} target="_blank" rel="noreferrer" className="hd-social-icon" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
            <a href={process.env.REACT_APP_INSTAGRAM} target="_blank" rel="noreferrer" className="hd-social-icon" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>

        <Row className="hd-footer-columns gy-4">
          <Col md={4}>
            <Link to="/" className="hd-footer-logo">
              <Logo />
            </Link>
            <p className="hd-footer-text">
              HOME DECO est une société spécialisée dans la conception, fabrication et la commercialisation de mobilier de bureaux et l'aménagement des espaces.
            </p>
          </Col>

          <Col md={2}>
            <h6 className="hd-footer-title">Produits</h6>
            <ul className="hd-footer-links">
              <li><Link to="/Bureau" className="hd-link-animation">Bureau</Link></li>
              <li><Link to="/Table" className="hd-link-animation">Table</Link></li>
              <li><Link to="/Chaise" className="hd-link-animation">Chaise</Link></li>
              <li><Link to="/Armoire" className="hd-link-animation">Rangement</Link></li>
              <li><Link to="/COMPTOIR-D'ACCUEIL" className="hd-link-animation">Comptoir d'accueil</Link></li>
            </ul>
          </Col>

          <Col md={3}>
            <h6 className="hd-footer-title">Liens utiles</h6>
            <ul className="hd-footer-links">
              <li><Link to="/About" className="hd-link-animation">À propos</Link></li>
              <li><Link to="/Payement" className="hd-link-animation">Mode de paiement</Link></li>
              <li><Link to="/Politique-de-confidentialité" className="hd-link-animation">Confidentialité</Link></li>
              <li><Link to="/Contact" className="hd-link-animation">Contact</Link></li>
            </ul>
          </Col>

          <Col md={3}>
            <h6 className="hd-footer-title">Contact</h6>
            <ul className="hd-footer-contact-info">
              <li className="hd-footer-contact-item">
                <span className="hd-footer-contact-icon"><FiMapPin /></span>
                <span>Zaouiet Sousse, Sousse, Tunisia, 4000</span>
              </li>
              <li className="hd-footer-contact-item">
                <span className="hd-footer-contact-icon"><FiMail /></span>
                <span>{process.env.REACT_APP_GMAIL}</span>
              </li>
              <li className="hd-footer-contact-item">
                <span className="hd-footer-contact-icon"><FiPhone /></span>
                <span>{process.env.REACT_APP_TEL}</span>
              </li>
            </ul>
          </Col>
        </Row>

        <div className="hd-footer-bottom">
          <span>©{currentYear} <a href={process.env.REACT_APP_WEB_URL} target="_blank" rel="noreferrer" className="hd-footer-link">{process.env.REACT_APP_WEB}</a></span>
          <span className="hd-divider">|</span>
          <span>Fait avec <FaHeart className="hd-heart-icon" /> en Tunisie</span>
        </div>
      </Container>
    </footer>
  );
};

export default Footers;
